import { setStore, getStore, removeStore } from '@/util/store'
import platInfo from '@/util/getPlatform.js'
import dayjs from 'dayjs'
import { uploadErrorLog } from '@/api/common'
const logs = {
  state: {
    logsList: getStore({ name: 'logsList' }) || [],
    logsTimer: null
  },
  mutations: {
    SET_LOGS_LIST: (state, logs) => {
      state.logsList.push(logs)
      try {
        setStore({
          name: 'logsList',
          content: state.logsList
        })
      } catch (error) {
        console.log('setStore error:', error)
        state.logsList = []
        removeStore({
          name: 'logsList'
        })
      }
    },
    CLEAR_LOGS_LIST: (state) => {
      state.logsList = []
      setStore({
        name: 'logsList',
        content: []
      })
    },
    SET_LOGS_TIMER: (state, logsTimer) => {
      state.logsTimer = logsTimer
    },
    CLEAR_LOGS_TIMER: (state) => {
      if (state.logsTimer) {
        clearInterval(state.logsTimer)
      }
      state.logsTimer = null
    }
  },
  actions: {
    // 添加错误日志
    addErrorLogs({ state, commit }, { stack, message }) {
      const logsObj = {
        userInfo: {},
        platInfo,
        errInfo: { stack, message },
        url: window.location.href,
        time: dayjs().format('YYYY-MM-DD HH:mm:ss')
      }
      commit('SET_LOGS_LIST', JSON.stringify(logsObj))
    },
    // 发送错误日志
    sendErrorLogs({ state, commit }) {
      if (state.logsTimer) {
        clearInterval(state.logsTimer)
      }
      const sendLogsTime = 30 * 60 * 1000 // 发送错误日志间隔
      const timer = setInterval(() => {
        if (state.logsList.length === 0) {
          return
        }
        uploadErrorLog({
          content: state.logsList,
          operator: 2 // 1：乘客端 2：后台 3：司机 4：系统 5：云滴管家 7：代理商
        }).catch((err) => {
          console.log(err)
        })
        commit('CLEAR_LOGS_LIST')
      }, sendLogsTime)
      commit('SET_LOGS_TIMER', timer)
    }
  }
}

export default logs
